<template>
  <div>
    <!-- TODO: Maybe refactor and merge with GuestsResultsView -->
    <div v-if="!isLoaded" />
    <v-list
      v-else-if="reservationsByTime.size > 0"
      class="pt-0"
      two-line
    >
      <v-list-item-group
        v-model="selected"
        @change="selectedChange"
      >
        <template v-for="[group, value] in reservationsByTime.entries()">
          <guest-list-header-row
            :key="group"
            :title="localized.hourMinTextFrom24hr(group) || ''"
            :incoming="guestCountsByTime.get(group)?.incoming"
            :seated="guestCountsByTime.get(group)?.seated"
          />
          <template v-for="(reservation, i) in value">
            <guest-list-row
              :key="`fp_g_${group}_r_${i}`"
              :reservation="reservation"
              :overbooked-tab-items="overbookedTabItemsForReservation.get(reservation.id)"
              unread-reservations
              compact
            />
            <v-divider
              v-if="i + 1 < value.length"
              :key="`${group}_${i}`"
            />
          </template>
        </template>
      </v-list-item-group>
    </v-list>
    <template v-else>
      <div class="d-flex h-100 flex-column justify-center align-center">
        <div>{{ $t('placeholder.no_reservations') }}</div>
      </div>
    </template>
    <!-- END Refactor -->
  </div>
</template>

<script lang="ts" setup>
import {
  computed, PropType, ref, toRef, watch,
} from 'vue';
import Reservation from '@/model/Reservation';
import useGuestCountsByTime from '@/composables/guest-counts-by-time';
import { useLocalized } from '@/components/helpers/vue2-helpers';
import store from '@/store/store';
import GuestListRow from '@/components/views/guests/GuestListRow.vue';
import GuestListHeaderRow from '@/components/views/guests/GuestListHeaderRow.vue';

const emit = defineEmits(['selected']);

const props = defineProps({
  reservationsByTime: { type: Object as PropType<Map<string, Reservation[]>>, required: true },
  selectedResId: { type: Number, required: false, default: undefined },
  isLoaded: { type: Boolean, required: false, default: true },
});

const localized = useLocalized();

const selected = ref<number | undefined>(props.selectedResId);

const overbookedTabItemsForReservation = computed(
  () => store.getters.dayOverbookedTabItemsForReservationId as Map<number, Set<number> | undefined>,
);

const { guestCountsByTime } = useGuestCountsByTime(toRef(props, 'reservationsByTime'));

watch(() => props.selectedResId, (id) => { selected.value = id; });

const selectedChange = (reservationId: number) => {
  emit('selected', reservationId);
};

</script>
